import { render, staticRenderFns } from "./ProcedureForm.vue?vue&type=template&id=1aa8ba82&scoped=true&"
import script from "./ProcedureForm.vue?vue&type=script&lang=js&"
export * from "./ProcedureForm.vue?vue&type=script&lang=js&"
import style0 from "./ProcedureForm.vue?vue&type=style&index=0&id=1aa8ba82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa8ba82",
  null
  
)

export default component.exports